/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
import { serializeHandles } from '@fluidframework/shared-object-base';
import { fail } from './Common';
/**
 * Serializes a SharedTree summary into a JSON string. This may later be used to initialize a SharedTree's state via `deserialize()`
 * Also replaces handle objects with their serialized form.
 *
 * @param summary - The SharedTree summary to serialize.
 * @param serializer - The serializer required to serialize handles in the summary.
 * @param bind - The object handle required to serialize handles in the summary
 */
export function serialize(summary, serializer, bind) {
    var _a;
    return (_a = serializeHandles(summary, serializer, bind)) !== null && _a !== void 0 ? _a : fail();
}
//# sourceMappingURL=Summary.js.map